import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';
import IGame from '@interfaces/IGame';
import { get } from 'lodash';

export const reset = createEvent('Games store reset');

export const getList = createEffect({
  name: 'getList',
  async handler(filter?: IGame['name']) {
    if (filter) {
      const response = await request(api.games.getList, { params: { filter } });
      return response;
    } else {
      return { data: [] };
    }
  },
});

export const getGameById = createEffect({
  name: 'getGameById',
  async handler(gameId: string) {
    const response = await request(api.games.getItem, {
      urlParams: { gameId },
    });
    return response;
  },
});

export const setList = createEvent<IGame[]>('Handle set game list');

const preloaders = createPreloadersStore([getList]);

const bodyPath = ['data', 'body'];

const list = createStore<IGame[]>([])
  .on(getList.done, (state, { result }) => get(result, [...bodyPath, 'content'], []))
  .on(setList, (_, list: IGame[]) => list)
  .on(getGameById.done, (_, { result }) => [get(result, bodyPath, null)])
  .reset(reset);

const gamesSelector = combine({ preloaders, list });

export default gamesSelector;
